<template>
  <div>
    <section>
      <v-container>
        <v-row id="top">
          <v-col
            id="citat"
            cols="12"
            sm="6"
            class="text-sm-center"
          >
            <v-card>
              <v-card-text class="pa-12">
                <div id="quote">
                  <v-icon class="px-1">
                    mdi-format-quote-open
                  </v-icon>
                  Vi har kunnat effektivisera hela vår kundhantering, vilket lett till att vi tjänar mer pengar och har lägre personalomsättning
                  <v-icon class="px-1">
                    mdi-format-quote-close
                  </v-icon>
                </div>
                <div id="quoted">
                  - Lennart, Örebro
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            id="cta"
            cols="12"
            sm="5"
            class="offset-sm-1"
          >
            <h1>Gör som Lennart,</h1>
            <h1>Uppgradera ert företag med Sunnycloud CRM</h1>

            <SignupButton text="Starta 14 dagars gratis testperiod" />
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="light-blue lighten-5 text-sm-center wide">
      <v-container>
        <v-row>
          <v-col cols="12" sm="4">
            <h2>
              <v-icon x-large color="grey darken-2">
                mdi-trophy
              </v-icon><br>
              Koll på kunden
            </h2>
            <p>Kundkortet ger all kundinformation i en vy och säljtavlan visar precis i vilket stadie alla era affärer befinner sig.</p>
            <p>Lägg därtill aktivitetslistor och smidiga arbetsflöden så får ni full koll på era kundrelationer och ert dagliga arbete.</p>
          </v-col>
          <v-col cols="12" sm="4">
            <h2>
              <v-icon x-large color="grey darken-2">
                mdi-lock
              </v-icon><br>
              Full kontroll
            </h2>
            <p>Styr vem i teamet som kan göra vad. Använd användarroller för att tex styra om en säljare bara kan redigera sina egna kunder, eller om hen får radera kunddata.</p>
            <p>Strukturera användarna med Teams där man bara kan se vad som händer i sitt team.</p>
          </v-col>
          <v-col cols="12" sm="4">
            <h2>
              <v-icon x-large color="grey darken-2">
                mdi-face-agent
              </v-icon><br>
              Enkelt att använda
            </h2>
            <p>Gränssnittet är vänligt, och det är enkelt att komma igång.</p>
            <p>Ibland, tex i början, kan det uppstå frågor, och då finns vi där tillsammand med er och rätar ut frågetecknen. Du får hjälp över såväl chat, telefon och via skärmdelning.</p>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section>
      <v-container class="slim text-center">
        <h2>
          Kom igång redan idag
        </h2>
        <SignupButton text="Skapa konto snabbt och enkelt" class="my-6" />
        <p>Ingen bindningstid, 14 dagars fri provperiod, alltid fri support</p>
      </v-container>
    </section>
  </div>
</template>

<script>
import SignupButton from '@/components/SignupButton'

export default {
  components: {
    SignupButton,
  },
}
</script>

<style lang="scss" scoped>
  #top {
    #cta {
      h1 {
        padding-bottom: 15px;

        &:last-of-type {
          padding-bottom: 40px;
        }
      }
    }
    #citat {
      align-self: center;

      @media screen and (min-width: 600px) {
        .v-card {
          box-shadow: 0px 0px 20px 0px rgba(101, 101, 101, 0.421);
          border-radius: 15px;
        }
      }
      @media screen and (max-width: 600px) {
        .v-card {
          box-shadow: 0px 0px 0px 0px rgba(101, 101, 101, 0.421);
          border-radius: 15px;

          .v-card__text {
            padding: 0px 0px 30px !important;
            text-align: center;
          }
        }
      }

      #quote {
      font-size: 150%;
      padding-bottom: 20px;
      }

      #quoted {
        font-size: 95%;
        color: #666;
      }
    }
  }
</style>
